import { memo as Memo, useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const PeezzyJump = Memo(({ animate }) => {
	const svgRef = useRef(null);
	const flRef = useRef(null);
	const frRef = useRef(null);
	const hlRef = useRef(null);
	const hrRef = useRef(null);
	const animRef = useRef(null);

	useEffect(() => {
		const tl = gsap.timeline({ paused: true });

		tl.to(svgRef.current, { duration: 0.2, y: -20 })
			.to(flRef.current, { duration: 0.2, svgOrigin: '92 123', rotation: 30 }, 0)
			.to(frRef.current, { duration: 0.2, svgOrigin: '141 123', rotation: -30 }, 0)
			.to(hlRef.current, { duration: 0.2, svgOrigin: '47 96', rotation: 30 }, 0)
			.to(hrRef.current, { duration: 0.2, svgOrigin: '193 96', rotation: -30 }, 0)
			.to(svgRef.current, { duration: 0.2, y: 0 }, 0.2)
			.to(flRef.current, { duration: 0.2, svgOrigin: '92 123', rotation: 0 }, 0.2)
			.to(frRef.current, { duration: 0.2, svgOrigin: '141 123', rotation: 0 }, 0.2)
			.to(hlRef.current, { duration: 0.2, svgOrigin: '47 96', rotation: 0 }, 0.2)
			.to(hrRef.current, { duration: 0.2, svgOrigin: '193 96', rotation: 0 }, 0.2);

		animRef.current = tl;

		return () => {
			tl.kill();
			animRef.current = null;
		};
	}, []);

	useEffect(() => {
		if (animate && animRef.current) {
			animRef.current.progress(0).play();
		}
	}, [animate]);

	return (
		<svg
			ref={svgRef}
			className={`svg-max peezzyJump`}
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 237.65 156.73'>
			<path
				className={'fill'}
				d='M0,1.42,54.77,128.89a1.88,1.88,0,0,0,1.74,1.1l126.17-.75a1.86,1.86,0,0,0,1.72-1.12L237.65,0S-.5.26,0,1.42Z'
			/>
			<path
				ref={hlRef}
				className={`peezzyJump-hl defaultStyle`}
				d='M47.23,96.18a45.9,45.9,0,0,0-10.14,32.45'
			/>
			<path
				ref={hrRef}
				className={`peezzyJump-hr defaultStyle`}
				d='M193,96.18a45.9,45.9,0,0,1,10.14,32.45'
			/>
			<path
				ref={flRef}
				className={`peezzyJump-fl defaultStyle`}
				d='M93.62,107.73c-.54,6-1.72,22.21-2.58,32.48a13,13,0,0,1-9.25,11.38l-5.63,1.67'
			/>
			<path
				ref={frRef}
				className={`peezzyJump-fr defaultStyle`}
				d='M135.54,109.45c.53,6,1.72,22.21,2.57,32.49a13,13,0,0,0,9.26,11.37L153,155'
			/>
		</svg>
	);
});

export default PeezzyJump;
